import { colors } from '../constants/colors';

export const getCustomStyles = () => `
  /* Legacy font classes kept for backward compat — markup uses font-display / font-sans via Tailwind */
  .font-playfair { font-family: 'Playfair Display', Georgia, 'Times New Roman', serif; }
  .font-montserrat { font-family: 'Montserrat', system-ui, -apple-system, 'Segoe UI', sans-serif; }

  .btn-primary {
    background-color: #FFA726;
    color: #17386E;
    transition: all 0.3s ease;
  }
  .btn-primary:hover {
    background-color: #f3911c;
    transform: translateY(-2px);
    box-shadow: 0 10px 30px -10px rgba(255, 167, 38, 0.55);
  }
  .btn-secondary {
    background-color: ${colors.bleuSavoir};
    color: white;
    transition: all 0.3s ease;
  }
  .btn-secondary:hover {
    background-color: #1F4A8C;
    transform: translateY(-2px);
  }

  @keyframes fadeIn {
    from { opacity: 0; transform: scale(0.95); }
    to { opacity: 1; transform: scale(1); }
  }
  .modal-animate {
    animation: fadeIn 0.3s ease-out forwards;
  }
`;
